// const normalizeAllergen = (value) => {
//   if (!value) return "None";
//   const normalized = value.trim().toLowerCase();
//   const noneValues = ["", "0", "n/a", "none", "#n/a"];
//   return noneValues.includes(normalized) ? "None" : value.trim();
// };


// ======================== using in alerts, workorder.jsx ===========

const normalizeAllergen = (value) => {
  if (!value) return "None";
  const normalized = value.toString().trim().toLowerCase();
  const noneValues = new Set([
    "", "0", "n/a", "none", "#n/a", "na", "n.a."
  ]);
  return noneValues.has(normalized) ? "None" : value.toString().trim();
};


export default normalizeAllergen; 